
// @ts-ignore
    import __i18nConfig from '@next-translate-root/i18n'
// @ts-ignore
    import __appWithI18n from 'next-translate/appWithI18n'
// @ts-ignore
    
import { FC } from 'react';
import { AppProps } from 'next/app';
import Script from 'next/script';
import { usePageLoader } from 'hooks/usePageLoader';
import AppWrapper from 'components/AppWrapper/AppWrapper';
import SeoHeader from 'components/Common/SeoHeader/SeoHeader';
import AppLoader from 'components/AppLoader/AppLoader';
import GoogleAnalytics from 'components/GoogleAnalytics/GoogleAnalytics';
import FullStory from 'components/FullStory/FullStory';
import useTranslation from 'next-translate/useTranslation';
import { renderSnippet } from 'utils/segment';

import '../styles/style.scss';

const MyApp: FC<AppProps> = ({ Component, pageProps }) => {
  const { t } = useTranslation();
  const { isAnimating } = usePageLoader();

  const title = t('appTitle');
  const description = t('appDescription');
  const link = `${process.env.BASE_URL}`;

  return (
    <>
      <SeoHeader title={title} description={description} link={link} />
      <AppLoader isAnimating={isAnimating} />
      <Script id="segment-script" dangerouslySetInnerHTML={{ __html: renderSnippet() }} />
      <GoogleAnalytics />
      <FullStory />
      <AppWrapper>
        <Component {...pageProps} />
      </AppWrapper>
    </>
  );
};

const __Page_Next_Translate__ = MyApp;


// @ts-ignore
    export default __appWithI18n(__Page_Next_Translate__, {
// @ts-ignore
      ...__i18nConfig,
// @ts-ignore
      isLoader: true,
// @ts-ignore
      skipInitialProps: false,
// @ts-ignore
      loadLocaleFrom: (l, n) => import(`@next-translate-root/locales/${l}/${n}`).then(m => m.default),
// @ts-ignore
    });
// @ts-ignore
  